import { Component } from '@angular/core';

import { OnInit } from '@angular/core';

import { FieldGeneratorService } from '../../services/field-generator.service';
import { FormDialogComponent } from '../form-dialog/form-dialog.component';
import { MatDialog } from '@angular/material';

import { MiscService } from '../../services/misc.service';
import { MessageService } from '../../services/message.service';
import { ConfirmationDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { GlobalCfgService } from 'src/services/globalcfg.service';
import { LinkDeviceDialogComponent } from './link-device-dialog/link-device-dialog.component';
import { SyncDevicesDialogComponent } from './sync-devices-dialog/sync-devices-dialog.component';
import { TrackingComponent } from '../live-tracking/tracking/tracking.component';

@Component({
  selector: 'rm-manage-device',
  templateUrl: './manage-device.component.html',
  styleUrls: ['./manage-device.component.css']
})
export class ManageDeviceComponent implements OnInit {

  data: any[] = [];
  columns: any[] = [
    // { name: 'serialNo', displayName: 'Serial No.' },
    { name: 'thingName', displayName: 'Device Name', editable: false },
    { name: 'alternateName', displayName: 'Alternate Name' },
    { name: 'isActive', displayName: 'Active?', type: 'boolean', editable: false },
    { name: 'isTracking', displayName: 'Tracking?', type: 'boolean', editable: false },
    { name: 'pushFrequency', displayName: 'Push Frequency (in seconds)', type: 'number', step: 5 },
    { name: 'linkedWithType', displayName: 'Linked With', editable: false },
    { name: 'linkedItemId', displayName: 'Instance Id', editable: false },
    { name: 'actions', displayName: 'Actions', type: 'actions' }
  ];
  gcp: any;
  devicesDiscovered: any[] = [];
  badgeData: any;

  constructor(
    private dialog: MatDialog,
    private fgService: FieldGeneratorService,
    private miscService: MiscService,
    private msgService: MessageService,
    private globalCfgService: GlobalCfgService,
  ) { }

  ngOnInit() {
    this.gcp = this.globalCfgService.getGcp();
    console.log("this.gcp", this.gcp);

    this.loadDevices();
  }

  loadDevices() {

    this.miscService.getDevices(this.gcp).subscribe(
      (response) => {
        var data = response['existing'];

        data.forEach(item => {

          item['actions'] = [{ name: 'edit', tip: 'Edit device data' }];

          if (!item.isActive) {
            item['actions'].push({ name: 'check', tip: 'Mark as Active' });
            item['actions'].push({ name: 'border_color', tip: 'Edit Device Link Details' });
          } else {
            item['actions'].push({ name: 'undo', tip: 'Mark as in-Active' });
            item['actions'].push({ name: 'link_off', tip: 'View Linked detail' });

            //tracking
            if (!item.isTracking) {
              item['actions'].push({ name: 'play_circle_outline', tip: 'Start tracking' });
            } else {
              item['actions'].push({ name: 'pause_circle_outline', tip: 'Stop tracking' });
            }

            //killed
            if (!item.isKilled) {
              item['actions'].push({ name: 'gavel', tip: 'Kill device' });
            }
          }

          if (item.linkId) {

            //tracking
            if (!item.isTracking) {
              if (item.hasPastTracking) {
                item['actions'].push({ name: 'place', tip: 'Track past history on map' });
              }
            } else {
              item['actions'].push({ name: 'my_location', tip: 'Live track on map' });
            }

          } else {
            item['actions'].push({ name: 'link', tip: 'Link Device' });
          }
        });
        this.data = data;
        this.devicesDiscovered = response["discovered"];
        if (this.devicesDiscovered.length == 0) {
          this.badgeData = ""
        } else {
          this.badgeData = this.devicesDiscovered.length;
        }
      });
  }

  sync() {
    const dialogRef = this.dialog.open(SyncDevicesDialogComponent, {
      width: '640px',
      data: {
        title: 'Discovered Devices',
        note: 'You may, optionally, enter an Alternate Name for these discovered devices to easily recognise them in the system.',
        devices: this.devicesDiscovered
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed', result);
      if (result && result.length > 0) {
        result.map(o => o.gcp = this.gcp)
        this.miscService.addDevice(result).subscribe(
          () => {
            this.msgService.showSuccess(this.msgService.devicesSynced);
            this.loadDevices();
          }
        );
      }
    });
  }

  onActionClicked(event) {
    var rec = event.record;
    switch (event.actionName.name) {
      case 'edit':
        var fields = this.fgService.getFields(this.columns, event.record);
        const dialogRef = this.dialog.open(FormDialogComponent, {
          width: '450px',
          data: {
            title: 'Edit Device Data',
            fields: fields
          }
        });
        dialogRef.afterClosed().subscribe(result => {
          console.log('The dialog was closed', result);
          if (result) {
            this.miscService.updateDevice({
              id: rec.id,
              alternateName: result.alternateName,
              pushFrequency: result.pushFrequency
            }).subscribe(
              (response) => {
                this.msgService.showSuccess(this.msgService.deviceDetailsUpdate);
                this.loadDevices();
              }
            );
          }
        });
        break;
      case 'check':
        const dialogRef2 = this.dialog.open(ConfirmationDialogComponent, {
          width: '450px',
          data: {
            note: 'Activating a device will prepare it for tracking. This will not automatically start tracking.',
            message: 'Are you sure you want to activate the device?'
          }
        });
        dialogRef2.afterClosed().subscribe(result => {
          if (result == 'yes') {
            this.miscService.updateDevice({
              id: rec.id,
              isActive: true
            }).subscribe(
              () => {
                this.msgService.showSuccess(this.msgService.deviceActivate);
                this.loadDevices();
              }
            );
          }
        });
        break;
      case 'undo':
        const dialogRef3 = this.dialog.open(ConfirmationDialogComponent, {
          width: '450px',
          data: {
            note: 'De-activating a device will also stop tracking of the linked ' + rec.linkedWithType + '.',
            message: 'Are you sure you want to de-activate the device?'
          }
        });
        dialogRef3.afterClosed().subscribe(result => {
          if (result == 'yes') {
            this.miscService.updateDevice({
              id: rec.id,
              isActive: false
            }).subscribe(
              () => {
                this.msgService.showSuccess(this.msgService.deviceDeactivate);
                this.loadDevices();
              }
            );
          }
        });
        break;
      case 'play_circle_outline':
        const dialogRef4 = this.dialog.open(ConfirmationDialogComponent, {
          width: '450px',
          data: {
            note: 'This is generally done when the trackable item is leaving your warehouse.',
            message: 'Are you sure you want to turn on the tracking for this device?'
          }
        });
        dialogRef4.afterClosed().subscribe(result => {
          console.log('The dialog was closed', result);
          if (result == 'yes') {
            this.miscService.updateDevice({
              id: rec.id,
              isTracking: true
            }).subscribe(
              () => {
                this.msgService.showSuccess(this.msgService.trackDisabled);
                this.loadDevices();
              }
            );
          }
        });
        break;
      case 'gavel':
        const dialogRef5 = this.dialog.open(ConfirmationDialogComponent, {
          width: '450px',
          data: {
            note: 'This is generally done when you have lost ownership of the device (e.g. stolen). This will make the device un-usable for tracking.',
            message: 'Are you sure you want to kill this device?'
          }
        });
        dialogRef5.afterClosed().subscribe(result => {
          console.log('The dialog was closed', result);
          if (result == 'yes') {
            this.miscService.updateDevice({
              id: rec.id,
              isKilled: true
            }).subscribe(
              () => {
                this.msgService.showSuccess(this.msgService.killCommand);
                this.loadDevices();
              }
            );
          }
        });
        break;
      case 'my_location':
        this.dialog.open(TrackingComponent, {
          width: '1200px',
          height: '550px',
          data: {
            title: "Live Tracking",
            record: rec,
            gln: rec.gln, 
            gcp: this.globalCfgService.getGcp(), 
            tracking: true
          }
        });
        break;
      case 'link':
        const dialogRef6 = this.dialog.open(LinkDeviceDialogComponent, {
          width: '500px',
          data: {
            title: 'Link Device'
          }
        });
        dialogRef6.afterClosed().subscribe(result => {
          console.log('The dialog was closed', result);
          if (result) {
            result.gcp = this.gcp;
            this.miscService.linkDevice(rec.id, result).subscribe(
              () => {
                this.msgService.showSuccess(this.msgService.deviceLinked);
                this.loadDevices();
              },
              error => {
                console.log("error response: ", error);
              }
            );
          }
        });
        break;
      case 'link_off':
        const dialogRef7 = this.dialog.open(LinkDeviceDialogComponent, {
          width: '500px',
          data: {
            title: 'View Device Data',
            record: rec,
            readOnly: true
          }
        });
        break;
      case 'border_color':
        const dialogRef8 = this.dialog.open(LinkDeviceDialogComponent, {
          width: '500px',
          data: {
            title: 'Edit Device Link Details',
            record: rec,
            editMode: true
          }
        });
        dialogRef8.afterClosed().subscribe(result => {
          console.log('The dialog was closed', result);
          if (result) {
            result.gcp = this.gcp;
            this.miscService.linkDevice(rec.id, result).subscribe(
              () => {
                this.msgService.showSuccess(this.msgService.deviceLinked);
                this.loadDevices();
              },
              error => {
                console.log("error response: ", error);
              }
            );
          }
        });
        break;
      case 'pause_circle_outline':
        var dialogRef9 = this.dialog.open(ConfirmationDialogComponent, {
          width: '450px',
          data: {
            message: 'Are you sure you want to turn off the tracking for this device?'
          }
        });
        dialogRef9.afterClosed().subscribe(result => {
          console.log('The dialog was closed', result);
          if (result == 'yes') {
            this.miscService.updateDevice({
              id: rec.id,
              isTracking: false
            }).subscribe(
              () => {
                this.msgService.showSuccess(this.msgService.trackingTurnedOff);
                this.loadDevices();
              }
            );
          }
        });
        break;
      case 'place':
        // past history
        const dialogRef10 = this.dialog.open(TrackingComponent, {
          width: '1200px',
          height: '550px',
          data: {
            title: "Past History",
            gln: rec.gln,
            gcp: this.globalCfgService.getGcp(),
            tracking: false,
            record: rec
          }
        });
        break;
      default:
        console.log('Unhandled action: ', event.actionName);
    }
  }
}